import apiDietPaymentProcessor from "./apiDietPaymentProcessor"

const EXPERTS = ["elina", "anna", "simona", "no_coach"]

// Brand-specific Premium upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
    chancePath,
    sendOffPath,
  } = {}) => ({
    // Init common upsell functionality

    ...commonUpsell({
      upsellOfferType: "chat",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      chancePath,
      sendOffPath,
    }),

    experts: EXPERTS,
    selectedExpert: EXPERTS[0],
    isPaymodeModalOpen: false,
    isPaymodeModalNeeded: false,
    chosenPaymentMethod: null,

    init() {
      this.commonInitUpsell()

      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.isLoading = false
          this.chosenPaymentMethod = null
        }
      })

      if (
        !this.store.values.lastPaymentMethod ||
        this.store.values.lastPaymentMethod !== "primer" ||
        !this.store.values.isCardSaved
      ) {
        this.isPaymodeModalNeeded = true
      }
    },

    selectExpert(id) {
      this.selectedExpert = this.experts[id - 1]

      this.store.internalTracker.trackClick({
        clickName: `Expert Selected`,
      })

      this.store.values.selectedChatNutrionist = this.selectExpert
    },

    isExpertSelected(id) {
      return this.selectedExpert === this.experts[id - 1]
    },

    isExpertRecommended(id) {
      return id === 1
    },

    isNoExpert(id) {
      return this.experts[id - 1] === "no_coach"
    },

    handlePayment(paymode, isModal) {
      if (this.selectedExpert === "no_coach") {
        this.goToChance()

        return
      }

      if (isModal) {
        this.store.values.selectedChatNutrionist = this.selectExpert
      }

      const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

      // Handle card-save payments
      if (!paymode && !this.isPaymodeModalNeeded) {
        this.isLoading = true
        const paymentParamsCardSave = {
          successStepPath: paymentsSuccessPath,
          failedStepPath: paymentsFailPath,
          paymentMethod: "primer",
          restrictCardSave: false,
          checkoutTemplate: "yg-ac-pipe",
        }

        handleCheckoutAndRedirect(paymentParamsCardSave)
        return
      }
      // Open up modal if there is no paymode
      if (!paymode && this.isPaymodeModalNeeded) {
        this.isPaymodeModalOpen = true

        return
      }
      // Handle payments that doesn't have save-card
      this.store.internalTracker.trackClick({
        clickName: (paymode === "paypal_recurring" ? "PayPal" : "Credit Card") + " Selected"
      })

      this.chosenPaymentMethod = paymode
      this.store.values.lastPaymentMethod = paymode
      this.isLoading = true
      const paymentParamsWithoutCardSave = {
        successStepPath: paymentsSuccessPath,
        failedStepPath: paymentsFailPath,
        paymentMethod: paymode,
        restrictCardSave: true,
        checkoutTemplate: "yg-ac-pipe",
      }

      handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
    },

    handleContinue() {
      if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
        this.store.values.isCardSaved = true
      }

      this.thankYouContinue()
    },

    handleAcceptOffer(paymode, isModal) {
      this.trackClickPurchase()

      this.handlePayment(paymode, isModal)
    },

    handleModalClose() {
      this.isPaymodeModalOpen = false
    },

    getSpinnerStatus(paymentMethod) {
      if (!this.isLoading) return false
      if (this.chosenPaymentMethod !== paymentMethod) return false

      return true
    },
  })
